import { render, staticRenderFns } from "./AdminReportedContent.vue?vue&type=template&id=2e03203e&scoped=true"
import script from "./AdminReportedContent.vue?vue&type=script&lang=js"
export * from "./AdminReportedContent.vue?vue&type=script&lang=js"
import style0 from "./AdminReportedContent.vue?vue&type=style&index=0&id=2e03203e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e03203e",
  null
  
)

export default component.exports